import {
  ListItem,
  UnorderedList,
  useToast,
  UseToastOptions,
} from "@chakra-ui/react";
import { FileError, FileRejection } from "react-dropzone";
import { formatFilesize } from "utils/formatting";

function getBetterTooLargeMessage(file: File, error: FileError) {
  const { code, message } = error;

  if (!message || code !== "file-too-large") return message;

  const matches = /(\d+) bytes/.exec(message);

  if (!matches) return message;

  const sizeLimit = parseFloat(matches[1]);

  if (!sizeLimit) return message;

  return `File is ${formatFilesize(file.size) ?? ""} but the limit is ${
    formatFilesize(sizeLimit) ?? ""
  }`;
}

const DEFAULT_TOAST_OPTIONS: UseToastOptions = {
  status: "error",
  duration: 10000,
  isClosable: true,
};

export default function useDropzoneRejectionToast() {
  const showToast = useToast(DEFAULT_TOAST_OPTIONS);

  return function showRejectionToast(rejections: FileRejection[]) {
    rejections.forEach((rejection) => {
      showToast({
        title: `Cannot upload file: ${rejection.file.name}`,
        description: (
          <UnorderedList>
            {rejection.errors.map((error) => (
              <ListItem key={error.code + error.message}>
                {error.code === "file-too-large"
                  ? getBetterTooLargeMessage(rejection.file, error)
                  : error.message}
              </ListItem>
            ))}
          </UnorderedList>
        ),
      });
    });
  };
}
